import { render } from "./LoginInvitados.vue?vue&type=template&id=5f5c1ec4"
import script from "./LoginInvitados.vue?vue&type=script&lang=js"
export * from "./LoginInvitados.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__